var _dec, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function _initializerWarningHelper(r, e) {
  throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
import './cg-notification.scss';
import { inject, bindable } from 'aurelia-framework';
import { getAWSBucketEndpoint, baseUrl } from 'environment';
import { Helper } from 'resources/extensions/helper';
import { Router } from 'aurelia-router';
export let CgNotification = (_dec = inject(Router, Helper), _dec(_class = (_class2 = class CgNotification {
  constructor(router, helper) {
    _initializerDefineProperty(this, "notificationData", _descriptor, this);
    _initializerDefineProperty(this, "selectedFilter", _descriptor2, this);
    _initializerDefineProperty(this, "loading", _descriptor3, this);
    _initializerDefineProperty(this, "functionChecked", _descriptor4, this);
    _initializerDefineProperty(this, "functionMarkRead", _descriptor5, this);
    this.baseAwsEndpoint = void 0;
    this.isHover = false;
    this.iconDefault = 'icons/default-notification-icon.svg';
    this.baseAwsEndpoint = getAWSBucketEndpoint('icons');
    this.router = router;
    this.helper = helper;
  }
  attached() {
    this.notificationData.checked = false;
  }
  mouseEventHandler(ev) {
    switch (ev.type) {
      case 'mouseenter':
        this.isHover = true;
        break;
      case 'mouseleave':
        this.isHover = false;
        break;
      default:
        break;
    }
  }
  loadIcon() {
    if (this.notificationData.imagePath || this.notificationData.preloadedIcon) {
      return this.notificationData.imagePath ? `${this.baseAwsEndpoint}${this.notificationData.imagePath}` : `${this.baseAwsEndpoint}${this.notificationData.preloadedIcon}`;
    } else {
      return `${baseUrl()}${this.iconDefault}`;
    }
  }
  handleNavigation(element) {
    const classesToCheck = ['check-material', 'bullet'];
    if (this.notificationData?.redirectTo && !classesToCheck.some(x => element.srcElement.classList.contains(x))) {
      this.functionMarkRead !== null && this.functionMarkRead();
      this.router.navigate(this.notificationData.redirectTo);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "notificationData", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selectedFilter", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "loading", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "functionChecked", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "functionMarkRead", [bindable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);